import { render, staticRenderFns } from "./MenuDetailModal.vue?vue&type=template&id=78173712&scoped=true&"
import script from "./MenuDetailModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuDetailModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuDetailModal.vue?vue&type=style&index=0&id=78173712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78173712",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconClose: require('/usr/www/nuxt/components/Icon/IconClose.vue').default,IconLotPlaceholder: require('/usr/www/nuxt/components/Icon/IconLotPlaceholder.vue').default})
